<template>
  <v-main class="tpadding">
    <v-container fluid>
      <sbtn text="Volver" :onClick="back" icon="mdi-arrow-left" colorBtn="blueKonect" typeButton="text" :load="false" alignIcon class="py-6" />
      <v-card class="rounded-xl elevation-5">
        <v-toolbar dense dark color="pinkKonect" elevation="2">
          <v-toolbar-title v-text="$route.name == 'EmpleadosYRutasDetalle' ? 'Administracion de empleados' : 'Nuevo empleado'" />
          <v-spacer></v-spacer>
          <sbtn text="Guardar" :disabled="!isWriting" :onClick="save" icon="mdi-upload" colorBtn="white" typeButton="text" :load="loading" />
        </v-toolbar>
        <v-form ref="formDetail" class="centerInfo" v-on:submit.prevent lazy-validation>
          <v-row>
            <v-col cols="4">
              <v-text-field prepend-icon="mdi-pound" label="Referencia empleado" :rules="[rules.required]" v-model="detail.referencia_empleado" :disabled="loading" requiered></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field prepend-icon="mdi-account" label="Nombre de empleado" :rules="[rules.required]" v-model="detail.nombre_empleado" :disabled="loading" requiered></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field prepend-icon="mdi-account" label="Apellido de empleado" :rules="[rules.required]" v-model="detail.apellido_empleado" :disabled="loading" requiered></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field prepend-icon="mdi-text" label="Campo flex 1" v-model="detail.campo_flex_1" :disabled="loading"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field prepend-icon="mdi-text" label="Campo flex 2" v-model="detail.campo_flex_2" :disabled="loading"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field prepend-icon="mdi-text" label="Campo flex 3" v-model="detail.campo_flex_3" :disabled="loading"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field prepend-icon="mdi-text" label="Campo flex 4" v-model="detail.campo_flex_4" :disabled="loading"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field prepend-icon="mdi-text" label="Campo flex 5" v-model="detail.campo_flex_5" :disabled="loading"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
      <br />
      <v-row no-gutters>
        <v-col cols="12" sm="5">
          <div>
            <v-card class="rounded-xl elevation-5 centerElement text-center" max-width="400">
              <v-toolbar dense dark color="pinkKonect" elevation="2">
                <v-toolbar-title>Rutas no asociadas</v-toolbar-title>
              </v-toolbar>
              <v-list>
                <v-autocomplete v-model="searchNoRoute" append-icon="mdi-chevron-down" prepend-icon="mdi-magnify" label="Rutas" :items="searchNoAso" clearable class="pa-5"></v-autocomplete>
                <v-list-item-group v-model="model1" class="scrollStyle" multiple color="blueKonect" style="max-height: 300px; overflow: scroll; overflow-x: hidden">
                  <div v-for="(item, i1) in noAsociate" :key="i1">
                    <v-list-item v-if="searchNoRoute == item.ruta || searchNoRoute == undefined">
                      <v-list-item-content @click="pass(item, 'left')">
                        <v-list-item-title v-text="item.ruta"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-list-item-group>
              </v-list>
            </v-card>
          </div>
        </v-col>
        <v-col style="display: flex; justify-content: center; align-items: center" class="py-5" cols="12" sm="2">
          <div>
            <sbtn :onClick="rightFunction" icon="mdi-arrow-collapse-right" colorBtn="blue" />
            <br />
            <br />
            <sbtn :onClick="leftFunction" icon="mdi-arrow-collapse-left" colorBtn="blue" />
          </div>
        </v-col>
        <v-col cols="12" sm="5">
          <template>
            <v-card class="rounded-xl elevation-5 centerElement text-center" max-width="400">
              <v-toolbar dense dark color="pinkKonect" elevation="2">
                <v-toolbar-title>Rutas asociadas</v-toolbar-title>
              </v-toolbar>
              <v-list>
                <v-autocomplete v-model="searchRoute" append-icon="mdi-chevron-down" prepend-icon="mdi-magnify" label="Rutas" :items="searchAso" clearable class="pa-5"></v-autocomplete>
                <v-list-item-group v-model="model2" multiple color="blueKonect" style="max-height: 300px; overflow: scroll; overflow-x: hidden">
                  <div v-for="(item, i2) in asociate" :key="i2">
                    <v-list-item v-if="searchRoute == item.ruta || searchRoute == undefined">
                      <v-list-item-content @click="pass(item, 'right')">
                        <v-list-item-title v-text="item.ruta"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-list-item-group>
              </v-list>
            </v-card>
          </template>
        </v-col>
      </v-row>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right style="white-space: pre-line">
        {{ errorList[codeError] }}
        {{ "\n\n" + this.codeError }}
      </v-snackbar>
    </v-container>
  </v-main>
</template>

<script>
import services from "@/utils/services";
import { sbtn } from "@/components";
import * as _ from "lodash";
import errorList from "@/utils/errorsList";

export default {
  name: "Clientes",
  components: {
    sbtn,
  },
  data: () => ({
    loading: false,
    success: false,
    errorList,
    msgSuccess: "",
    codeError: "",
    code: "",
    error: false,
    path: "/client/EmpleadosYRutas",
    search: "",
    referencia_empleado: 0,
    items: [],
    noAsociate: [],
    asociate: [],
    auxAsociate: [],
    auxNoAsociate: [],
    detail: {
      referencia_empleado: "",
      nombre_empleado: "",
      apellido_empleado: "",
      campo_flex_1: "",
      campo_flex_2: "",
      campo_flex_3: "",
      campo_flex_4: "",
      campo_flex_5: "",
    },
    model1: [],
    model2: [],
    searchNoAso: [],
    searchAso: [],
    searchNoRoute: undefined,
    searchRoute: undefined,
    idCliente: "",
    idEmpleado: "",
    rules: {
      required: (v) => !!v || "El campo es requerido",
    },
  }),
  mounted() {
    if (this.isReading) {
      this.idCliente = this.$route.params.idCliente;
      this.idEmpleado = this.$route.params.idEmpleado;
      this.refresh();
    }
  },
  computed: {
    isReading: function () {
      return services.check(1, this.path);
    },
    isWriting: function () {
      return services.check(2, this.path);
    },
  },
  methods: {
    refresh() {
      this.loading = true;
      let data = {
        idcliente_externo: this.idCliente,
        idempleado_cliente_externo: this.idEmpleado,
      };
      if (this.$route.name == "EmpleadosYRutasDetalle") {
        this.axios
          .post(services.routes.employeesClientInfo, { data })
          .then((res) => {
            res = res.data.data;
            this.detail.referencia_empleado = res.empleado.referencia_empleado;
            this.detail.nombre_empleado = res.empleado.nombre_empleado;
            this.detail.apellido_empleado = res.empleado.apellido_empleado;
            this.detail.campo_flex_1 = res.empleado.campo_flex_1 == null ? "" : res.empleado.campo_flex_1;
            this.detail.campo_flex_2 = res.empleado.campo_flex_2 == null ? "" : res.empleado.campo_flex_2;
            this.detail.campo_flex_3 = res.empleado.campo_flex_3 == null ? "" : res.empleado.campo_flex_3;
            this.detail.campo_flex_4 = res.empleado.campo_flex_4 == null ? "" : res.empleado.campo_flex_4;
            this.detail.campo_flex_5 = res.empleado.campo_flex_5 == null ? "" : res.empleado.campo_flex_5;
            if (this.$route.name == "EmpleadosYRutasDetalle") {
              for (let i = 0; i < res.rutas_cliente.length; i++) {
                //obtengo las rutas asignadas desde empleado.rutas y les agrego la variable exist para poder tener cuales son las asignadas
                _.find(res.empleado.rutas, (e) => {
                  if (e === res.rutas_cliente[i].idruta) {
                    res.rutas_cliente[i].exists = true;
                  }
                });
              }
            }
            for (let i = 0; i < res.rutas_cliente.length; i++) {
              if (res.rutas_cliente[i].exists == true) {
                this.asociate.push({
                  ruta:
                    (res.rutas_cliente[i].idruta ? res.rutas_cliente[i].idruta + "/" : "") +
                    (res.rutas_cliente[i].nombre_ruta ? res.rutas_cliente[i].nombre_ruta : "") +
                    (res.rutas_cliente[i].tipo_servicio ? "/" + (res.rutas_cliente[i].tipo_servicio == "M" ? "Mete" : res.rutas_cliente[i].tipo_servicio == "S" ? "Saca" : "") : ""),
                  idruta: res.rutas_cliente[i].idruta,
                });
                this.searchAso.push(
                  (res.rutas_cliente[i].idruta ? res.rutas_cliente[i].idruta + "/" : "") +
                    (res.rutas_cliente[i].nombre_ruta ? res.rutas_cliente[i].nombre_ruta : "") +
                    (res.rutas_cliente[i].tipo_servicio ? "/" + (res.rutas_cliente[i].tipo_servicio == "M" ? "Mete" : res.rutas_cliente[i].tipo_servicio == "S" ? "Saca" : "") : "")
                );
              } else {
                this.searchNoAso.push(
                  (res.rutas_cliente[i].idruta ? res.rutas_cliente[i].idruta + "/" : "") +
                    (res.rutas_cliente[i].nombre_ruta ? res.rutas_cliente[i].nombre_ruta : "") +
                    (res.rutas_cliente[i].tipo_servicio ? "/" + (res.rutas_cliente[i].tipo_servicio == "M" ? "Mete" : res.rutas_cliente[i].tipo_servicio == "S" ? "Saca" : "") : "")
                );
                this.noAsociate.push({
                  ruta:
                    (res.rutas_cliente[i].idruta ? res.rutas_cliente[i].idruta + "/" : "") +
                    (res.rutas_cliente[i].nombre_ruta ? res.rutas_cliente[i].nombre_ruta : "") +
                    (res.rutas_cliente[i].tipo_servicio ? "/" + (res.rutas_cliente[i].tipo_servicio == "M" ? "Mete" : res.rutas_cliente[i].tipo_servicio == "S" ? "Saca" : "") : ""),
                  idruta: res.rutas_cliente[i].idruta,
                });
              }
            }
          })
          .catch((error) => {
            this.error = true;
            this.codeError = error.response.data.code;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.axios
          .get(services.routes.routesByClient + "/" + this.idCliente)
          .then((response) => {
            this.asociate = [];
            this.noAsociate = [];
            let res = response.data.data;
            if (this.$route.name == "nuevoEmpleado") {
              for (let i = 0; i < res.length; i++) {
                res[i].exists = false;
              }
            }
            for (let i = 0; i < res.length; i++) {
              if (res[i].exists == true) {
                this.asociate.push({
                  ruta:
                    (res[i].idruta ? res[i].idruta + "/" : "") +
                    (res[i].nombre_ruta ? res[i].nombre_ruta : "") +
                    (res[i].tipo_servicio ? "/" + (res[i].tipo_servicio == "M" ? "Mete" : res[i].tipo_servicio == "S" ? "Saca" : "") : ""),
                  idruta: res[i].idruta,
                });
                this.searchAso.push(
                  (res[i].idruta ? res[i].idruta + "/" : "") +
                    (res[i].nombre_ruta ? res[i].nombre_ruta : "") +
                    (res[i].tipo_servicio ? "/" + (res[i].tipo_servicio == "M" ? "Mete" : res[i].tipo_servicio == "S" ? "Saca" : "") : "")
                );
              }
              if (res[i].exists == false) {
                this.searchNoAso.push(
                  (res[i].idruta ? res[i].idruta + "/" : "") +
                    (res[i].nombre_ruta ? res[i].nombre_ruta : "") +
                    (res[i].tipo_servicio ? "/" + (res[i].tipo_servicio == "M" ? "Mete" : res[i].tipo_servicio == "S" ? "Saca" : "") : "")
                );
                this.noAsociate.push({
                  ruta:
                    (res[i].idruta ? res[i].idruta + "/" : "") +
                    (res[i].nombre_ruta ? res[i].nombre_ruta : "") +
                    (res[i].tipo_servicio ? "/" + (res[i].tipo_servicio == "M" ? "Mete" : res[i].tipo_servicio == "S" ? "Saca" : "") : ""),
                  idruta: res[i].idruta,
                });
              }
            }
          })
          .catch((error) => {
            this.error = true;
            this.codeError = error.response.data.code;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    pass(data, side) {
      let valid = true;
      if (side === "left") {
        for (let i = 0; i < this.noAsociate.length; i++) {
          if (data == this.noAsociate[i]) {
            for (let i = 0; i < this.auxAsociate.length; i++) {
              if (data == this.noAsociate[i]) {
                valid = false;
              }
            }
          }
        }
        if (valid) {
          this.auxAsociate.push(data);
          this.searchAso.push(data.ruta);
        }
      }
      if (side === "right") {
        for (let i = 0; i < this.asociate.length; i++) {
          if (data == this.asociate[i]) {
            for (let i = 0; i < this.auxNoAsociate.length; i++) {
              if (data == this.asociate[i]) {
                valid = false;
              }
            }
          }
        }

        if (valid) {
          this.auxNoAsociate.push(data);
          this.searchNoAso.push(data.ruta);
        }
      }
    },
    rightFunction() {
      for (let i = 0; i < this.auxAsociate.length; i++) {
        this.asociate.unshift(this.auxAsociate[i]);
        for (let j = 0; j < this.noAsociate.length; j++) {
          if (this.auxAsociate[i] == this.noAsociate[j]) {
            this.noAsociate.splice(j, 1);
          }
        }

        for (let j = 0; j < this.searchNoAso.length; j++) {
          if (this.auxAsociate[i].ruta == this.searchNoAso[j]) {
            this.searchNoAso.splice(j, 1);
          }
        }
      }
      this.model1 = [];
      this.auxAsociate = [];
    },
    leftFunction() {
      for (let i = 0; i < this.auxNoAsociate.length; i++) {
        this.noAsociate.unshift(this.auxNoAsociate[i]);
        for (let j = 0; j < this.asociate.length; j++) {
          if (this.auxNoAsociate[i] == this.asociate[j]) {
            this.asociate.splice(j, 1);
          }
        }

        for (let j = 0; j < this.searchAso.length; j++) {
          if (this.auxNoAsociate[i].ruta == this.searchAso[j]) {
            this.searchAso.splice(j, 1);
          }
        }
      }

      this.model2 = [];
      this.auxNoAsociate = [];
    },
    save() {
      if (this.$refs.formDetail.validate()) {
        let routes = [];
        for (let i = 0; i < this.asociate.length; i++) {
          routes.push(this.asociate[i].idruta);
        }
        let data = {
          data: {
            idempleado_cliente_externo: this.idEmpleado,
            referencia_empleado: this.detail.referencia_empleado.toString(),
            nombre_empleado: this.detail.nombre_empleado,
            apellido_empleado: this.detail.apellido_empleado,
            campo_flex_1: this.detail.campo_flex_1,
            campo_flex_2: this.detail.campo_flex_2,
            campo_flex_3: this.detail.campo_flex_3,
            campo_flex_4: this.detail.campo_flex_4,
            campo_flex_5: this.detail.campo_flex_5,
            idsrutas: routes,
          },
        };
        if (this.$route.name == "EmpleadosYRutasDetalle") {
          services
            .ws("put", "employeesProgram", data)
            .then((res) => {
              this.refresh();
              this.success = true;
              this.msgSuccess = "Usuario actualizado correctamente";
            })
            .catch((error) => {
              this.error = true;
              this.codeError = error.response.data.code;
            })
            .finally(() => {
              this.loading = false;
              this.back();
            });
        } else {
          delete data.data.idempleado_cliente_externo;
          services
            .ws("post", "employeesProgram", data)
            .then((res) => {
              this.refresh();
              this.success = true;
              this.msgSuccess = "Usuario creado correctamente";
            })
            .catch((error) => {
              this.error = true;
              this.codeError = error.response.data.code;
            })
            .finally(() => {
              this.loading = false;
              this.back();
            });
        }
      }
    },
    back() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.centerInfo {
  padding: 15px;
}
.scrollStyle {
  scrollbar-color: #e22d871c #fcfcfc00 !important;
  scrollbar-base-color: rgba(61, 213, 233, 0.137);
}
::-webkit-scrollbar {
  width: 12px;
}
::-webkit-scrollbar-track {
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
}
.centerElement {
  margin-left: auto;
  margin-right: auto;
}
</style>
